import { Injectable } from '@angular/core';
import { BehaviorSubject } from 'rxjs';
import { IMspCompanyEscalationOrder, IMspConfigAllowedUser, IMspConfigNocSocResponse } from '../models/msp-config';
import { ManagedServicesRepository } from './managed-services-repository.service';

@Injectable({
  providedIn: 'root',
})
export class ManagedServicesConfigService {
  constructor(private managedServiceRepository: ManagedServicesRepository) {}

  /** Behavior subjects to hold noc/soc config */
  private nocSocConfig = new BehaviorSubject<IMspConfigNocSocResponse>(null);

  /** Behavior subjects to hold company escalation order */
  private companyEscalationOrder = new BehaviorSubject<IMspCompanyEscalationOrder>(null);

  /** Behavior subjects to hold allowed users config */
  private allowedUsersConfig = new BehaviorSubject<IMspConfigAllowedUser[]>(null);

  /** Noc/Soc config observable */
  companyEscalationSettings$ = this.nocSocConfig.asObservable();

  /** Company escalation order observable */
  companyEscalationOrder$ = this.companyEscalationOrder.asObservable();

  /** Allowed users config observable */
  allowedUsersConfig$ = this.allowedUsersConfig.asObservable();

  /**
   * Update noc/soc config
   */
  fetchCompanyEscalationSettings() {
    this.nocSocConfig.next(null);
    this.managedServiceRepository.getMspConfigNocSoc().subscribe((config) => {
      this.nocSocConfig.next(config);
    });
  }

  /**
   * Update allowed users config
   */
  fetchAllowedUsersConfig() {
    this.allowedUsersConfig.next(null);
    this.managedServiceRepository.getMspConfigAllowedUsers().subscribe((config) => {
      this.allowedUsersConfig.next(config);
    });
  }

  /**
   * Update company escalation order
   */
  fetchCompanyEscalationOrder() {
    this.companyEscalationOrder.next(null);
    this.managedServiceRepository.getCompanyEscalationOrder().subscribe((config) => {
      this.companyEscalationOrder.next(config);
    });
  }
}
